import React from 'react';
import { Link } from 'react-router-dom';
import { GlobeIcon, FacebookIcon, TwitterIcon, InstagramIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gray-900 text-white pt-16 pb-8 w-full" data-id="element-367">
      <div className="container mx-auto px-4" data-id="element-368">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12" data-id="element-369">
          {/* Company info */}
          <div data-id="element-370">
            <div className="flex items-center mb-4" data-id="element-371">
              <div className="h-10 w-10 rounded-full bg-white flex items-center justify-center mr-2" data-id="element-372">
                <GlobeIcon className="h-6 w-6 text-[#2563EB]" data-id="element-373" />
              </div>
              <span className="text-xl font-bold" data-id="element-374">TravelSIM</span>
            </div>
            <p className="text-gray-400 mb-4" data-id="element-375">
              Connecting travelers worldwide with instant eSIM solutions for
              190+ countries.
            </p>
            <div className="flex space-x-4" data-id="element-376">
              <a href="#" className="text-gray-400 hover:text-white" data-id="element-377">
                <FacebookIcon className="h-5 w-5" data-id="element-378" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white" data-id="element-379">
                <TwitterIcon className="h-5 w-5" data-id="element-380" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white" data-id="element-381">
                <InstagramIcon className="h-5 w-5" data-id="element-382" />
              </a>
            </div>
          </div>
          {/* Quick links */}
          <div data-id="element-383">
            <h3 className="font-semibold text-lg mb-4" data-id="element-384">Quick Links</h3>
            <ul className="space-y-2" data-id="element-385">
              <li data-id="element-386">
                <a href="#plans" className="text-gray-400 hover:text-white transition-colors" data-id="element-387">
                  Plans
                </a>
              </li>
              <li data-id="element-388">
                <a href="#how-it-works" className="text-gray-400 hover:text-white transition-colors" data-id="element-389">
                  How It Works
                </a>
              </li>
              <li data-id="element-390">
                <a href="#faq" className="text-gray-400 hover:text-white transition-colors" data-id="element-391">
                  FAQ
                </a>
              </li>
              <li data-id="element-392">
                <Link to="/help" className="text-gray-400 hover:text-white transition-colors" data-id="element-393">
                  Help Center
                </Link>
              </li>
              <li data-id="element-394">
                <Link to="/blog" className="text-gray-400 hover:text-white transition-colors" data-id="element-395">
                  Blog
                </Link>
              </li>
            </ul>
          </div>
          {/* Support */}
          <div data-id="element-396">
            <h3 className="font-semibold text-lg mb-4" data-id="element-397">Support</h3>
            <ul className="space-y-2" data-id="element-398">
              <li data-id="element-399">
                <Link to="/contact" className="text-gray-400 hover:text-white transition-colors" data-id="element-400">
                  Contact Us
                </Link>
              </li>
              <li data-id="element-401">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-402">
                  Live Chat
                </a>
              </li>
              <li data-id="element-403">
                <Link to="/help" className="text-gray-400 hover:text-white transition-colors" data-id="element-404">
                  Help Center
                </Link>
              </li>
              <li data-id="element-405">
                <Link to="/installation-guide" className="text-gray-400 hover:text-white transition-colors" data-id="element-406">
                  Installation Guides
                </Link>
              </li>
            </ul>
          </div>
          {/* Legal */}
          <div data-id="element-407">
            <h3 className="font-semibold text-lg mb-4" data-id="element-408">Legal</h3>
            <ul className="space-y-2" data-id="element-409">
              <li data-id="element-410">
                <Link to="/terms-privacy" className="text-gray-400 hover:text-white transition-colors" data-id="element-411">
                  Terms of Service
                </Link>
              </li>
              <li data-id="element-412">
                <Link to="/terms-privacy" className="text-gray-400 hover:text-white transition-colors" data-id="element-413">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-414">
                <Link to="/refund-policy" className="text-gray-400 hover:text-white transition-colors" data-id="element-415">
                  Refund Policy
                </Link>
              </li>
              <li data-id="element-416">
                <Link to="/terms-privacy" className="text-gray-400 hover:text-white transition-colors" data-id="element-417">
                  Cookie Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>
        {/* Bottom section */}
        <div className="pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center" data-id="element-418">
          <p className="text-gray-400 text-sm mb-4 md:mb-0" data-id="element-419">
            © 2023 TravelSIM. All rights reserved.
          </p>
          <div className="flex items-center" data-id="element-420">
            <GlobeIcon className="h-4 w-4 text-gray-400 mr-2" data-id="element-421" />
            <select className="bg-transparent border-none text-sm text-gray-400 focus:outline-none" data-id="element-422">
              <option value="en" data-id="element-423">English</option>
              <option value="ar" data-id="element-424">Arabic</option>
              <option value="fr" data-id="element-425">French</option>
            </select>
          </div>
        </div>
      </div>
    </footer>;
}